// extracted by mini-css-extract-plugin
module.exports = {"file":"style__file__+ny7p","buttons":"style__buttons__lDde6"};